import { AfterViewInit, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuGroup, MenuItem } from "../../models/menu";
import { ConfigProvider } from "../../../config-provider.service";
import { NgIf } from "@angular/common";
import { MatMiniFabButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'side-menu',
  providers: [],
  styleUrls: ['./side-menu.scss'],
  standalone: true,
  imports: [
    NgIf,
    MatMiniFabButton,
    RouterLink,
    MatIcon
  ],
  templateUrl: './side-menu.html'
})
export class SideMenuComponent implements AfterViewInit {
    public get menuGroups() {
        return this._menuGroups;
    }
    @Input() public set menuGroups(menuGroups: MenuGroup[]) {
        this._menuGroups = menuGroups;
        this._changeDetector.detectChanges();
    }
    public isMenuVisibleOnSmallScreen = false;
    public currentUrl: string|null = null;

    @Input() public neverHide = false;

    private _menuGroups: MenuGroup[] = [];
    constructor(
        public conf: ConfigProvider,
        private _router: Router,
        private _changeDetector: ChangeDetectorRef,
        private _translater: TranslateService
    ) {
    }

    public ngAfterViewInit() {
        this.currentUrl = this._router.url;
        this._changeDetector.detectChanges();
    }

    public onToggleMenuClicked(event: any): void {
        event.stopPropagation();
        this.isMenuVisibleOnSmallScreen = !this.isMenuVisibleOnSmallScreen;
    }

    public onMenuItemClicked(menu: MenuItem): void {
        if (menu.onClicked) {
            menu.onClicked();
        } else if (menu.url) {
            this._router.navigateByUrl(menu.url);
        }
    }
}
